import { Button, Flex } from "@eworkit/iris";
import React, { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

import { Text } from "@/components/Text";

interface IConfirmSectionProps {
  onClose: () => void;
  updateStep: Dispatch<SetStateAction<number>>;
}

const ConfirmSection = ({ onClose, updateStep }: IConfirmSectionProps) => {
  const { t } = useTranslation("session");

  return (
    <>
      <Flex justifyContent="center" mt="md">
        <div className="delete__img-container" />
      </Flex>

      <Flex flexDirection="column" mt="md" mb="sm" gap="sm">
        <Text>{t("USERS.SETTINGS.USER_ACCOUNT.CONVERT_PROFILE.CONFIRM_DIALOG.TEXT1")}</Text>
      </Flex>

      <Flex justifyContent="flex-end">
        <Flex gap="sm">
          <Button
            variant="secondary"
            onClick={() => {
              onClose();
              updateStep(1);
            }}
            size="lg">
            <Text>{t("USERS.SETTINGS.USER_ACCOUNT.CONVERT_PROFILE.BUTTON_CANCEL")}</Text>
          </Button>

          <Button onClick={() => updateStep(2)} size="lg">
            <Text>{t("USERS.SETTINGS.USER_ACCOUNT.CONVERT_PROFILE.CONFIRM_DIALOG.BUTTON_APPROVE")}</Text>
          </Button>
        </Flex>
      </Flex>
    </>
  );
};

export default ConfirmSection;
